module.exports = __webpack_public_path__ + "img/hexagon.6ea4b17e.png";